module.exports = __webpack_public_path__ + "56d7289476fc3ae0c2f13fae5650205f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/meredicte_512c.png
// module id = 321
// module chunks = 1